import { Control } from "../../business-objects/control/control.model";
import { MembershipControlConfig } from "./membership-control-config.model";

export class MembershipControl extends Control {
    config: MembershipControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/membership/membership-control.model.ts